import React from 'react';
import { motion } from 'framer-motion';
import { FileText, ShoppingCart, Droplets, MessageSquare, Map, HelpCircle } from 'lucide-react';
const deliverables = [{
  icon: FileText,
  title: "La Guía Maestra 'Adiós Pañal en 3 Días'",
  description: 'PDF paso a paso con el sistema completo.'
}, {
  icon: ShoppingCart,
  title: 'El Inventario de Guerra',
  description: 'Lista de compras exacta en Target/Walmart.'
}, {
  icon: Droplets,
  title: "El Protocolo 'Hidrata-y-Observa'",
  description: 'Para activar la vejiga de forma controlada.'
}, {
  icon: MessageSquare,
  title: 'Script de Comunicación para Maestras',
  description: 'Qué decir para que no le pongan pañal en el daycare.'
}, {
  icon: Map,
  title: 'Mapa de Accidentes',
  description: 'Herramienta para identificar los patrones de tu hijo.'
}, {
  icon: HelpCircle,
  title: 'FAQ de Emergencia',
  description: 'Respuestas directas para el domingo a las 11 PM.'
}];
export function WhatYouGetSection() {
  return <section className="bg-white py-14 px-4" data-id="element-153">
      <div className="max-w-6xl mx-auto" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-155">
          <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-156">
            Todo lo que recibes hoy
          </h2>
          <p className="text-xl text-gray-600" data-id="element-157">
            Tu arsenal completo para el fin de semana del éxito.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-158">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream p-6 rounded-3xl border border-light-teal/50 hover:shadow-xl hover:border-soft-teal transition-all group" data-id="element-159">
              <div className="w-14 h-14 bg-white rounded-2xl shadow-sm flex items-center justify-center mb-4 group-hover:scale-110 transition-transform" data-id="element-160">
                <item.icon className="text-coral w-7 h-7" data-id="element-161" />
              </div>
              <h3 className="text-lg font-bold text-dark-teal mb-2 leading-tight" data-id="element-162">
                {item.title}
              </h3>
              <p className="text-gray-600" data-id="element-163">{item.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}